import { isFetcherError, FetchError } from '../client';
export function isApiError(error) {
    if (!isFetcherError(error))
        return false;
    return error.status !== 422;
}
